import { UserModel } from './../models/user.model';
import { StorageService } from './storage.service';
import { AlertService } from './alert.service';
import { MissionService } from './mission.services';
import { Injectable, Type } from '@angular/core';
import { AppConfig } from '../app/app.config';
import { AuthService } from './auth.service';
import * as $ from 'jquery';
import 'signalr';
import layer from 'layui-layer';
import { ReconnectionService } from "./../services/reconnection.service";
import { baseConfig } from "./../assets/js/config.js";

@Injectable()
export class SignalrService {

    // connection: SignalR.Hub.Connection;
    AppConfig = AppConfig;
    public connected: boolean = false;
    public static connectTimes: number = 0;
    private timer: any;

    constructor(
        private mission: MissionService,
        private auth: AuthService,
        private alert: AlertService,
        private storage: StorageService,
        private reconnectionService: ReconnectionService,
    ) { }


    init(signalrUrl) {
        let url = signalrUrl ? signalrUrl : baseConfig.signalrLink;
        if (this.connected) {
            return;
        }
        AppConfig.connection = $.hubConnection(url, { qs: 'Authorization=' + this.auth.getToken() });
        // this.connection = $.hubConnection(baseConfig.signalrLink, { qs: 'Authorization=' + this.auth.getToken() });
        let hubProxy = AppConfig.connection.createHubProxy('legendHub');
        hubProxy.on('getNotification', d => {
            this.mission.announceMission(d);
            this.getEvents(d);
        });

        /**断线重连 */
        if (AppConfig.connetionFlag) {
            AppConfig.connection.disconnected(() => {
                this.connected = false;
                this.reconnected();
            }).error((error) => {

            });


            this.startConnection();
        }
    }

    reconnected() {
        this.stop();
        let self = this;
        this.timer = setInterval(() => {
            if (!self.connected && AppConfig.connetionFlag) {
                clearInterval(this.timer);
                this.startConnection();
            }
        }, 5000)
    }

    startConnection() {
        AppConfig.connection.start().done(() => {
            if (SignalrService.connectTimes == 0) {
                console.log('signalr connected successful');
                SignalrService.connectTimes += 1;
            } else {
                console.log('signalr reconnected successful');
                this.reconnectionService.setValue(true);
            }
            this.connected = true;
            if (this.timer) {
                clearInterval(this.timer);
            }
        }).fail(() => {
            console.log('signalr connect failed');
            this.reconnectionService.setValue(false);
        });
    }


    stop() {
        AppConfig.connection.stop(true, true);
    }

    //监听事件
    //TQQ 2017-05-11
    getEvents(d) {
        switch (d['Type']) {
            case 'Kickout':
                layer.alert('网络延迟', {
                    icon: 1,
                    title: '提示',
                    time: 3000,
                    yes: s => {
                        layer.close(s);
                    },
                    end: e => {
                        this.auth.logout();
                    }
                });
                break;
            case 'ResetLoginPwd':
                layer.alert('已重置登录密码', {
                    icon: 1,
                    title: '提示',
                    time: 3000,
                    yes: s => {
                        layer.close(s);
                    },
                    end: e => {
                        this.auth.logout();
                    }
                });
                break;
            case 'UserCapital': //用户信息
            case 'UserExpand':
            case 'UserInfo':
                let user = this.storage.read<UserModel>("User");
                $.extend(user, d['Data']);
                this.storage.write("User", user);
                AppConfig.User = user;
                break;
            case 'UserMessage':
                this.onUserMessage(d['Data']);
                break;
            case 'UserNotice':
                this.onUserNotice(d['Data']);
                break;
            case "Announcement":
            case "Release"://公告推送
                layer.open({
                    title: d['Data'].Title,
                    anim: 2,
                    type: 1,
                    skin: 'GongGao',
                    area: ['800px', '670px'],
                    content: d['Data'].Summary,
                    icon: 7
                });
                break;
            case 'OtherPlaceLogin'://被迫下线
                layer.alert('该帐户已在其它地方登录，您将退出。如果不是本人操作，您的密码可能已泄露，请尽快修改密码。', {
                    icon: 1,
                    title: '提示',
                    time: 3000,
                    yes: s => {
                        layer.close(s);
                    },
                    end: e => {
                        this.auth.logout();
                    }
                });
                break;
        }
    }
    //消息提醒
    //TQQ 2017-05-11
    onUserMessage(msg) {
        let title = "", content = "";
        if (msg.TypeCode == '01') {
            title = '上级发来的消息';
            content = msg.Contect;
        } else if (msg.TypeCode == '02') {
            title = '下级发来的消息';
            content = msg.Contect + '-' + msg.sendUserName;
        } else {
            title = '系统发来的消息';
            content = msg.Contect;
        }
        // layer.msg(content);
        this.alert.WarnInfor(content, title);
    }

    //通知消息
    //TQQ 2017-05-11
    onUserNotice(notice) {
        if (notice.Title) {
            if (notice.Title.indexOf('中奖消息') >= 0 && AppConfig.canPlayWinning) {
                var audio = document.createElement("audio");
                audio.src = "./../assets/mp3/winning.mp3";
                audio.play();
            }
        }
        let content = notice.Contect;
        this.alert.WarnInfor(content, notice.Title);
    }
}


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/providers/signalr.service.ts